module.exports = __webpack_public_path__ + "static/media/medicare-card-new.13d493f8.png";